import { render, staticRenderFns } from "./InfographyInPractise.vue?vue&type=template&id=0068412d&"
import script from "./InfographyInPractise.vue?vue&type=script&lang=ts&"
export * from "./InfographyInPractise.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports